module.exports = __webpack_public_path__ + "img/Lima_cargo.1b646fce.svg";